import { supabase } from '@/integrations/supabase/client';

export interface DestinoRetomada {
  quadro: string;
  coluna: string;
  statusId: string | null;
}

// Colunas que NÃO são destino válido de retomada (são o próprio estado
// recuperado/cancelado, não um lugar de trabalho pra onde voltar).
const COLUNAS_INVALIDAS = new Set(['PEDIDO RECUPERADO', 'PEDIDO CANCELADO']);

// Resolve pra onde a retomada deve mandar o item: o EXATO quadro/coluna/status
// de onde foi cancelado (snapshot salvo no cancelamento).
//
// Itens cancelados/recuperados VÁRIAS vezes têm o snapshot mais recente poluído
// (aponta pro próprio PEDIDO RECUPERADO/CANCELADO). Por isso varremos o histórico
// e pegamos o snapshot VÁLIDO mais recente. Sem nenhum válido = CRIAÇÃO PEDIDO
// (garante que o item SEMPRE sai do recuperado — nunca vira no-op).
export async function resolverDestinoRetomada(itemId: string): Promise<DestinoRetomada> {
  try {
    // Item sem input nunca esteve na operadora: a foto no PRE_ATIVO é a da
    // recuperação errada por titularidade (2610220046) e não vale como destino.
    const { data: item } = await supabase
      .from('itens_pedido')
      .select('dt_input')
      .eq('id', itemId)
      .maybeSingle();
    const semInput = !item?.dt_input;

    const { data: rows } = await (supabase as any)
      .from('item_cancelamentos')
      .select('snapshot_anterior, recuperado_em')
      .eq('item_id', itemId)
      .eq('recuperado', true)
      .order('recuperado_em', { ascending: false })
      .limit(10);

    for (const r of rows || []) {
      const snap = (r?.snapshot_anterior as any) || null;
      const quadro = snap?.quadro_atual;
      const coluna = snap?.coluna_atual;
      if (
        quadro &&
        coluna &&
        quadro !== 'PEDIDO_CANCELADO' &&
        !(quadro === 'PRE_ATIVO' && semInput) &&
        !COLUNAS_INVALIDAS.has(String(coluna).toUpperCase().trim())
      ) {
        // O Input realizado Fixa saiu em 30/10/2026: a fixa cancelada lá volta
        // para a Em instalação, como faz fn_retomar_pedido.
        if (String(coluna).toUpperCase().trim() === 'INPUT REALIZADO FIXA') {
          return { quadro, coluna: 'EM INSTALAÇÃO', statusId: null };
        }
        return { quadro, coluna, statusId: snap?.status_id ?? null };
      }
    }
  } catch (err) {
    console.error('[resolverDestinoRetomada] erro:', err);
  }
  return { quadro: 'CONTRATO_PRIME', coluna: 'CRIAÇÃO PEDIDO', statusId: null };
}
